/* Quaza Track bar, on every Track page (the hub and the set pages): docks under the theme's header,
   the light/dark switch, the sliding thumb of segmented controls, and the Sets menu
   (snippets/track-sets-menu.liquid). The hub's other menus are built by price-tracker-page.js; the
   two never stay open together (they tell each other through the 'qpt:menu' event). */
(function () {
  'use strict';
  var root = document.querySelector('.qpt[data-qpt], .qpt[data-qpt-set-page]');
  if (!root || root.__qptNav) return;
  root.__qptNav = true;

  /* ---------- dock right under the header ----------
     Impulse makes #SiteHeader itself position:fixed once scrolled and slides it in and out, so the
     bar follows the header's live bottom edge rather than a one-off height. */
  var siteHeader = document.querySelector('.site-header');
  var lastTop = null;
  function setStickyTop() {
    var h = 0;
    if (siteHeader) {
      var own = getComputedStyle(siteHeader).position;
      var par = getComputedStyle(siteHeader.parentElement || siteHeader).position;
      if (own === 'fixed' || own === 'sticky' || par === 'fixed' || par === 'sticky') {
        h = Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom));
      }
    }
    if (h !== lastTop) { lastTop = h; root.style.setProperty('--qpt-sticky-top', h + 'px'); }
  }
  setStickyTop();
  window.addEventListener('resize', setStickyTop, { passive: true });
  var raf = 0;
  window.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; setStickyTop(); });
  }, { passive: true });
  if (siteHeader && window.MutationObserver) {
    var settle = 0; // the header turns fixed after our frame runs, then slides in
    new MutationObserver(function () { setStickyTop(); clearTimeout(settle); settle = setTimeout(setStickyTop, 360); })
      .observe(siteHeader, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  /* ---------- light / dark (the section's pre-paint script already applied the saved choice) ---------- */
  var themeBtn = root.querySelector('[data-qpt-theme]');
  function themeLabel() {
    if (themeBtn) themeBtn.setAttribute('aria-label', root.getAttribute('data-theme') === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
  }
  if (themeBtn) {
    themeLabel();
    themeBtn.addEventListener('click', function () {
      var dark = root.getAttribute('data-theme') !== 'dark';
      if (dark) root.setAttribute('data-theme', 'dark'); else root.removeAttribute('data-theme');
      try { localStorage.setItem('qpt-theme', dark ? 'dark' : 'light'); } catch (e) { /* private mode */ }
      themeLabel();
    });
  }

  /* ---------- segmented controls: one thumb slides to the pressed button ----------
     Until the thumb has a place (a control inside a hidden menu has no size yet) the pressed button
     keeps its own background, so the control always reads. */
  function placeThumb(seg) {
    var on = seg.querySelector('button[aria-pressed="true"]');
    var ok = !!(on && seg.__qptThumb && seg.offsetWidth && on.offsetWidth);
    if (ok) {
      seg.style.setProperty('--qpt-seg-x', on.offsetLeft + 'px');
      seg.style.setProperty('--qpt-seg-w', on.offsetWidth + 'px');
    }
    seg.classList.toggle('is-live', ok);
  }
  function armSeg(seg) {
    if (seg.__qptThumb) { placeThumb(seg); return; }
    var thumb = document.createElement('span');
    thumb.className = 'qpt-seg-thumb';
    thumb.setAttribute('aria-hidden', 'true');
    seg.insertBefore(thumb, seg.firstChild);
    seg.__qptThumb = thumb;
    thumb.style.transition = 'none'; // no slide on the first placement
    placeThumb(seg);
    requestAnimationFrame(function () { requestAnimationFrame(function () { thumb.style.transition = ''; }); });
    if (window.MutationObserver) {
      new MutationObserver(function () { placeThumb(seg); })
        .observe(seg, { subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'hidden'] });
    }
    if (window.ResizeObserver) new ResizeObserver(function () { placeThumb(seg); }).observe(seg);
  }
  function armSegs(scope) {
    var segs = (scope || root).querySelectorAll('.qpt-seg');
    for (var i = 0; i < segs.length; i++) armSeg(segs[i]);
  }
  armSegs();

  /* Was a click inside node? Read from the event's path, fixed when the click began, not from
     node.contains(target): a menu that redraws part of itself under the click has detached the
     target by the time the click reaches the document, and contains() then says "outside". */
  function within(ev, node) {
    if (!node) return false;
    var path = ev.composedPath ? ev.composedPath() : null;
    return path && path.length ? path.indexOf(node) !== -1 : node.contains(ev.target);
  }

  /* ---------- the Sets menu ----------
     The hub prints it inline; a set page names where to fetch it (data-qpt-sets-src, the
     track-sets-menu section) and loads it the first time the tab is pointed at or opened. */
  var tab = root.querySelector('[data-qpt-setstab]');
  var api = { armSegs: armSegs, within: within, closeSets: function () {} };
  window.QuazaTrackNav = api;
  if (!tab) return;

  var menu = root.querySelector('[data-qpt-setsmenu]');
  var loading = null;
  var isOpen = false;
  var want = null; // where to land once open: { lang, era }
  var find, langSeg, erasEl, none, lists;
  var lang = 'EN';
  var era = {}; // language -> era key picked on phones

  function fold(t) { return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function list() { return menu.querySelector('.qpt-sm-cols[data-l="' + lang + '"]'); }

  function load() {
    if (menu) return Promise.resolve(menu);
    if (loading) return loading;
    var src = tab.getAttribute('data-qpt-sets-src');
    if (!src || !window.fetch) return Promise.reject(new Error('no menu'));
    loading = fetch(src, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (html) {
        var m = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-qpt-setsmenu]');
        if (!m) throw new Error('no menu in the response');
        m = document.importNode(m, true);
        var here = location.pathname;
        m.querySelectorAll('a[href]').forEach(function (a) { if (a.getAttribute('href') === here) a.setAttribute('aria-current', 'page'); });
        tab.closest('.qpt-meganav').appendChild(m);
        menu = m;
        wire();
        return menu;
      })
      .catch(function (e) { loading = null; throw e; });
    return loading;
  }

  /* logos: the first time a list shows, each link gets its logo slot (lazy, so only the ones in view
     download; a set with no logo keeps an empty slot so the names line up) */
  function dressLogos(cols) {
    if (!cols || cols.__dressed) return;
    cols.__dressed = true;
    var base = menu.getAttribute('data-base') || '';
    cols.querySelectorAll('a').forEach(function (a) {
      var g = a.getAttribute('data-g');
      var n;
      if (g) {
        n = document.createElement('img');
        n.loading = 'lazy';
        n.decoding = 'async';
        n.alt = '';
        n.src = base + g;
      } else {
        n = document.createElement('span');
      }
      n.className = 'qpt-sm-logo';
      a.insertBefore(n, a.firstChild);
    });
  }

  /* the chip row is built once per language; picking an era only marks it (rebuilding the row under
     the tap detached the tapped chip, so the outside-click check below read it as a tap outside the
     menu and closed it, and the row lost its scroll position) */
  function renderEras() {
    erasEl.textContent = '';
    var groups = list().querySelectorAll('.qpt-sm-grp');
    var keys = Array.prototype.map.call(groups, function (g) { return g.getAttribute('data-era'); });
    if (keys.indexOf(era[lang]) === -1) era[lang] = keys[0];
    for (var i = 0; i < groups.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'qpt-chipbtn';
      b.setAttribute('data-era', keys[i]);
      b.textContent = groups[i].getAttribute('data-en');
      erasEl.appendChild(b);
    }
    markEra();
  }
  function markEra() {
    var key = era[lang];
    list().querySelectorAll('.qpt-sm-grp').forEach(function (g) { g.classList.toggle('is-on', g.getAttribute('data-era') === key); });
    erasEl.querySelectorAll('[data-era]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-era') === key ? 'true' : 'false'); });
  }
  function pickLang(l) {
    lang = l;
    for (var i = 0; i < lists.length; i++) lists[i].hidden = lists[i].getAttribute('data-l') !== l;
    langSeg.querySelectorAll('[data-l]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-l') === l ? 'true' : 'false'); });
    dressLogos(list());
    renderEras();
    filter();
  }
  function filter() {
    var words = fold(find.value.trim()).split(/\s+/).filter(Boolean);
    menu.classList.toggle('is-finding', !!words.length);
    var any = false;
    list().querySelectorAll('.qpt-sm-grp').forEach(function (g) {
      var shown = 0;
      g.querySelectorAll('li').forEach(function (li) {
        var a = li.firstElementChild;
        var k = a.__k || (a.__k = fold(a.textContent + ' ' + g.getAttribute('data-en')));
        var hit = words.every(function (w) { return k.indexOf(w) !== -1; });
        li.hidden = !hit;
        if (hit) shown++;
      });
      g.hidden = !shown;
      if (shown) any = true;
    });
    none.hidden = any;
  }
  function wire() {
    find = menu.querySelector('[data-qpt-sm-find]');
    langSeg = menu.querySelector('[data-qpt-sm-lang]');
    erasEl = menu.querySelector('[data-qpt-sm-eras]');
    none = menu.querySelector('[data-qpt-sm-none]');
    lists = menu.querySelectorAll('.qpt-sm-cols');
    tab.setAttribute('aria-controls', menu.id);
    erasEl.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-era]');
      if (!b || b.getAttribute('aria-pressed') === 'true') return;
      era[lang] = b.getAttribute('data-era');
      markEra();
      menu.scrollTop = 0;
      // keep the picked chip in view in the sideways row
      var r = erasEl.getBoundingClientRect(), c = b.getBoundingClientRect();
      if (c.left < r.left || c.right > r.right) {
        erasEl.scrollTo({ left: erasEl.scrollLeft + c.left - r.left - (r.width - c.width) / 2, behavior: reduced() ? 'auto' : 'smooth' });
      }
    });
    langSeg.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-l]');
      if (b) pickLang(b.getAttribute('data-l'));
    });
    var t = 0;
    find.addEventListener('input', function () { clearTimeout(t); t = setTimeout(filter, 60); });
    find.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { // Enter opens the first match
        var first = list().querySelector('li:not([hidden]) a');
        if (first) { ev.preventDefault(); location.href = first.href; }
      }
    });
    // its own links close it first, so Back returns to a closed menu
    menu.addEventListener('click', function (ev) { if (ev.target.closest('a[href]')) close(false); });
  }
  if (menu) wire();

  function show(viaKeyboard) {
    setStickyTop();
    menu.hidden = false;
    if (want && want.lang) { if (want.era) era[want.lang] = want.era; pickLang(want.lang); }
    else if (!erasEl.firstChild) pickLang(lang);
    armSegs(menu);
    if (want && want.era && window.matchMedia('(min-width: 750px)').matches) {
      var g = list().querySelector('.qpt-sm-grp.is-on');
      if (g) menu.scrollTop = Math.max(0, g.getBoundingClientRect().top - menu.getBoundingClientRect().top + menu.scrollTop - 72);
    }
    want = null;
    if (viaKeyboard) find.focus({ preventScroll: true });
  }
  function open(viaKeyboard, target) {
    want = target || null;
    if (isOpen && !target) return;
    isOpen = true;
    tab.setAttribute('aria-expanded', 'true');
    root.dispatchEvent(new CustomEvent('qpt:menu', { detail: { open: 'sets' } }));
    if (menu) { show(viaKeyboard); return; }
    tab.setAttribute('aria-busy', 'true');
    load().then(function () {
      tab.removeAttribute('aria-busy');
      if (isOpen) show(viaKeyboard);
    }, function () {
      // nothing to show: the hub lists every set, so go there
      tab.removeAttribute('aria-busy');
      isOpen = false;
      tab.setAttribute('aria-expanded', 'false');
      location.href = tab.getAttribute('data-qpt-sets-home') ||
        ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/price-tracker';
    });
  }
  function close(returnFocus) {
    if (!isOpen) return;
    isOpen = false;
    if (menu) menu.hidden = true;
    tab.setAttribute('aria-expanded', 'false');
    if (returnFocus) tab.focus({ preventScroll: true });
  }
  api.closeSets = function () { close(false); };
  tab.setAttribute('aria-expanded', 'false');
  tab.addEventListener('click', function (ev) {
    ev.preventDefault();
    if (isOpen) close(false); else open(ev.detail === 0);
  });
  // a set page warms the menu up as soon as the tab is in reach
  ['pointerenter', 'touchstart', 'focus'].forEach(function (t) {
    tab.addEventListener(t, function () { load().catch(function () {}); }, { once: true, passive: true });
  });
  root.addEventListener('qpt:menu', function (ev) { if (ev.detail && ev.detail.open !== 'sets') close(false); });
  document.addEventListener('click', function (ev) {
    if (isOpen && !within(ev, menu) && !within(ev, tab)) close(false);
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && isOpen) close(true);
  });

  /* a set page's era crumb opens the menu on that era (its href, the hub, is the no-script way) */
  root.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-qpt-open-sets]');
    if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button) return;
    ev.preventDefault();
    ev.stopPropagation(); // the document handler would close it again
    open(ev.detail === 0, { lang: a.getAttribute('data-lang') === 'JP' ? 'JP' : 'EN', era: a.getAttribute('data-era') });
  });
})();
